import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import {
    Icon,
    TemplateTitle,
} from 'src/common/components/templateDetails/TemplateDetails.styled';
import {DARK_NAVY_FONT_COLOR, SEMANTIC_TEXT_XSMALL_PX,} from 'src/styles/fonts/MCFontConstants';

export const OrderDetailTitleContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    box-sizing: border-box;
    justify-content: space-between;
    align-items: center;
    ${media.mobileDevice`
    width: 102%;
    padding: ${(props) => props.padding};
`}
`;

export const CloseIconContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    order: 3;
    width: 5%;
    padding: ${(props) => props.padding};
    ${media.mobileDevice`
        order: 2;
        width: 49%;
    `}
`;

export const CloseIcon = styled(Icon)``;

export const TitleSubContainer = styled.div`
    display: flex;
    order: 2;
    width: 75%;
    align-items: center;

    ${media.mediumDevice`
        width: 73%;
    `}

    ${media.smalDevice`
        width: 70%;
    `}
    ${media.mobileDevice`
        order: 3;
        width: 100%;
    `}
`;

export const TitleDateContainer = styled.div`
    display: flex;
    justify-content: space-between;
    width: 95%;
    margin-left: ${({ isMargin }) => (isMargin ? isMargin : '0')};
`;

export const SurgeryDateContainer = styled.div`
    display: flex;
`;

export const OrderDetailTitle = styled(TemplateTitle)`
    font-size: 18px;
    /* width: 20%; */
    ${media.mediumDevice`
        width: 22%;
    `}
    ${media.smalDevice`
        width: 25%;
    `}
    ${media.mobileDevice`
        width: 50%;
    `}
`;

export const Title = styled.div`
    font-family: AvenirNextWorld Regular;
    font-size: ${SEMANTIC_TEXT_XSMALL_PX};
    color: ${({ color }) => (color ? color : DARK_NAVY_FONT_COLOR)};
    
`;
